import React, { useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo_dark from "../assets/img/logo.png";
import { resetPassword } from "../common/api";
import { ShowToast } from "../common/function";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email;


  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
      newErrors.newPassword = "Password must include at least one special symbol";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setLoading(true);
      const response = await resetPassword({ newPassword: newPassword, email });
      setLoading(false);

      if (response.success) {
        ShowToast(1, "Password reset successfully");
        navigate("/");
      } else {
        ShowToast(0, response.message || "Something went wrong");
      }
    } catch (err) {
      setLoading(false);
      ShowToast(0, "Something went wrong. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo_dark} alt="ZenFlow Logo" />
              <h2>
                Reset <span>Password</span>
              </h2>
              <p>Please enter the details below to reset your password.</p>
            </div>

            <Form onSubmit={handleSubmit}>
              {/* New Password */}
              <Form.Group className="mb-4 form-group">
                <Form.Label>New Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    isInvalid={!!errors.newPassword}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      zIndex: 10,
                    }}
                  >
                    {showPassword ? (
                      <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M13.359 11.238l1.28 1.28-1.06 1.06-1.28-1.28C11.547 12.79 9.836 13.5 8 13.5c-3.747 0-7-3.25-7-5.5 0-.98.403-1.86 1.077-2.536l-1.28-1.28 1.06-1.06 13.438 13.438-1.06 1.06-1.28-1.28zM3.924 4.924A4.978 4.978 0 008 3.5c3.043 0 5.5 2.686 5.5 4s-2.457 4-5.5 4a4.978 4.978 0 01-4.076-2.424l.5-.5z" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 3.5c-3.747 0-7 3.25-7 5.5s3.253 5.5 7 5.5 7-3.25 7-5.5-3.253-5.5-7-5.5zM8 11.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z" />
                        <path d="M8 5.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z" />
                      </svg>
                    )}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors.newPassword}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              {/* Confirm Password */}
              <Form.Group className="mb-4 form-group">
                <Form.Label>Confirm New Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showConfirm ? "text" : "password"}
                    placeholder="Enter confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    isInvalid={!!errors.confirmPassword}
                  />
                  <span
                    onClick={() => setShowConfirm(!showConfirm)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      zIndex: 10,
                    }}
                  >
                    {showConfirm ? (
                      <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M13.359 11.238l1.28 1.28-1.06 1.06-1.28-1.28C11.547 12.79 9.836 13.5 8 13.5c-3.747 0-7-3.25-7-5.5 0-.98.403-1.86 1.077-2.536l-1.28-1.28 1.06-1.06 13.438 13.438-1.06 1.06-1.28-1.28zM3.924 4.924A4.978 4.978 0 008 3.5c3.043 0 5.5 2.686 5.5 4s-2.457 4-5.5 4a4.978 4.978 0 01-4.076-2.424l.5-.5z" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 3.5c-3.747 0-7 3.25-7 5.5s3.253 5.5 7 5.5 7-3.25 7-5.5-3.253-5.5-7-5.5zM8 11.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z" />
                        <path d="M8 5.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z" />
                      </svg>
                    )}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>

              <Button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </Button>

              <p className="formfooter text-center mt-3">
                Back To <Link to="/">Login</Link>
              </p>
            </Form>
          </div>
        </Col>

        <Col lg={6} className="loginmb_none">
          <div className="loginlogo_div">
            <Link to="/">
              <img src={logo_dark} alt="Logo" />
            </Link>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}
